import React from 'react';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import Container from './components/Container';

function UiPidsConstructor({
  isForm,
  callbacks,
  custom_pid,
  isDuplicate,
  form_ancestor,
  initial_layout,
  custom_ancestor,
  setup_rbox_light,
}) {
  return (
    <DndProvider backend={HTML5Backend}>
      <Container
        isForm={isForm}
        callbacks={callbacks}
        custom_pid={custom_pid}
        isDuplicate={isDuplicate}
        form_ancestor={form_ancestor}
        initial_layout={initial_layout}
        custom_ancestor={custom_ancestor}
        setup_rbox_light={setup_rbox_light}
      />
    </DndProvider>
  );
};

export default (UiPidsConstructor);
